<template>
    <div id="login-form" class="container">
        <div class="row py-5">
            <h3 class="col-12">{{this.$store.state.role}} Signup</h3>
        </div>
        <div class="row text-left align-items-center">
            <b-form @submit.prevent="signup" class="col-12 col-md-6 col-lg-4 mx-auto">
                <b-form-group label="First Name" label-for="firstName">
                    <b-form-input id="firstName" v-model="firstName"
                                  type="text" placeholder="Your Name"/>
                </b-form-group>
                <b-form-group label="Last Name" label-for="lastName">
                    <b-form-input id="lastName" v-model="lastName"
                                  type="text" placeholder="Your Last Name"/>
                </b-form-group>
                <b-form-group label="Email" label-for="email">
                    <b-form-input id="email" v-model="signUpEmail"
                                  type="email" placeholder="email@example.com"/>
                </b-form-group>
                <b-form-group label="Password" label-for="password">
                    <b-form-input id="password" v-model="signUpPassword"
                                  type="password" placeholder="*******"/>
                </b-form-group>
                <b-form-group label="ConfirmPassword" label-for="confirmPassword">
                    <b-form-input id="confirmPassword" v-model="confirmPassword"
                                  type="password" placeholder="*******"/>
                </b-form-group>
                <div class="text-center py-3">
                    <b-button class="m-1" pill @click="reset" variant="dark">Back</b-button>
                    <b-button class="m-1" pill @click="signup">Signup</b-button>
                </div>
            </b-form>
        </div>
        <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
                <p>{{ errorMsg }}</p>
            </div>
        </transition>
        <div class="py-5">
            <a @click="goLogin">Already have an account? Login</a><br>
        </div>
    </div>
</template>

<script>
import firebase from '../../firebase';

export default {
    name: 'SignUpForm',
    data() {
        return {
            firstName: '',
            lastName: '',
            signUpEmail: '',
            signUpPassword: '',
            confirmPassword: '',
            errorMsg: ''
        };
    },
    methods: {
        validateFields() {
            if (this.firstName.length === 0) {
                this.errorMsg = 'Insert your First Name';
            } else if (this.lastName.length === 0) {
                this.errorMsg = 'Insert your Last Name';
            } else if (this.signUpEmail.length === 0) {
                this.errorMsg = 'Insert your Email';
            } else if (this.signUpPassword.length < 6) {
                this.errorMsg = 'Your Password should be at least 6 chars long';
            } else if (this.signUpPassword !== this.confirmPassword) {
                this.errorMsg = 'Your password are not the same';
            }
        },
        signup() {
            this.errorMsg = '';
            this.$emit('requesting', true);
            this.validateFields();
            if (this.errorMsg === '') {
                firebase.auth.createUserWithEmailAndPassword(this.signUpEmail, this.signUpPassword)
                    .then((response) => {
                        firebase.usersCollection.doc(response.user.uid).set({
                            firstName: this.firstName,
                            lastName: this.lastName,
                            email: this.signUpEmail,
                            role: this.$store.state.role
                        }).then(() => {
                            this.$store.commit('setCurrentUser', response.user);
                            this.$store.dispatch('fetchUserProfile');
                            this.$router.push({ name: 'Home' });
                            this.$emit('requesting', false);
                        }).catch((err) => {
                            console.log(err);
                            this.errorMsg = err.message;
                            this.$emit('requesting', false);
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.$emit('requesting', false);
            }
        },
        reset() {
            this.$emit('resetRole');
        },
        goLogin() {
            this.$emit('goLogin');
        }
    }
};
</script>
